import { render, staticRenderFns } from "./backEnd.vue?vue&type=template&id=7bc26dcf&"
import script from "./backEnd.vue?vue&type=script&lang=js&"
export * from "./backEnd.vue?vue&type=script&lang=js&"
import style0 from "./backEnd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "backEnd.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarSideIcon } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContent,
  VNavigationDrawer,
  VSnackbar,
  VSpacer,
  VToolbar,
  VToolbarItems,
  VToolbarSideIcon,
  VToolbarTitle,
})
